export default __webpack_public_path__ + "static/presse-fest-oberammergau-1-preview-2ec7a793101f2446a8b5eba683759f21.jpg";